import { lazy } from 'react'
import langConfig from "@configs/langConfig"
const {t} = langConfig
// admin section
const AppSettings = [
    {
        path: '/admin/settings/audiences',
        title : t('Audiences'),
        component: lazy(() => import('../../../views/admin/settings/audiences')),
        meta: {
            isAdmin: true,
        }
    },
    {
        path: '/admin/settings/organizations',
        title : t('Organizations'),
        component: lazy(() => import('../../../views/admin/settings/organizations')),
        meta: {
            isAdmin: true,
        }
    },
    {
        path: '/admin/settings/industries',
        title : t('Industries'),
        component: lazy(() => import('../../../views/admin/settings/industries')),
        meta: {
            isAdmin: true,
        }
    },
    {
        path: '/admin/settings/status-type',
        title : t('Status type'),
        component: lazy(() => import('../../../views/admin/settings/status-type')),
        meta: {
            isAdmin: true,
        }
    },
    // {
    //     path: '/admin/settings/media-type',
    //     component: lazy(() => import('../../../views/admin/settings/media-type')),
    // },
    {
        path: '/admin/settings/threat-actors',
        title: t('Threat actors'),
        component: lazy(() => import('../../../views/admin/settings/threat-actors')),
        meta: {
            isAdmin: true,
        }
    },
    {
        path: '/admin/settings/tactics',
        title : t('Tactics'),
        component: lazy(() => import('../../../views/admin/settings/tactics')),
        meta: {
            isAdmin: true,
        }
    },
    {
        path: '/admin/settings/channels',
        title : t('Channels'),
        component: lazy(() => import('../../../views/admin/settings/channels')),
        meta: {
            isAdmin: true,
        }
    },
    {
        path: '/admin/settings/severities',
        title: t('Severities'),
        component: lazy(() => import('../../../views/admin/settings/severity')),
        meta: {
            isAdmin: true,
        }
    },
]


export default AppSettings